import { render, staticRenderFns } from "./GPScreenshotEvent.vue?vue&type=template&id=8acad842&"
import script from "./GPScreenshotEvent.vue?vue&type=script&lang=js&"
export * from "./GPScreenshotEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports